import { render } from "./PreparationView.vue?vue&type=template&id=976be452&scoped=true"
import script from "./PreparationView.vue?vue&type=script&lang=js"
export * from "./PreparationView.vue?vue&type=script&lang=js"

import "./PreparationView.vue?vue&type=style&index=0&id=976be452&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-976be452"]])

export default __exports__